import { $http } from '@/utils';

/**
 * @namespace Service
 * @class UserDepartment
 * @exports Service/Account/UserDepartment
 * @description API UserDepartment Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class UserDepartment {
	/**
	 * @static @name patch
	 * @description Update some User Department for ID
	 * @param {String} id
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static patch(id, payload) {
		return $http.patch(`account/user/department/${id}`, payload);
	}
}
